module.exports = __webpack_public_path__ + "static/media/nessa-win.a32d9312.png";